import { getPostHogKey } from "../../services/utils";
import { initializePostHog } from "./init";

const postHog = initializePostHog();

// Checks the tenant-prefixed key first (e.g. ingrezza_neurocrine_call_focus),
// then falls back to the bare key (e.g. call_focus) for global flags.
function isEnabled(key: string): boolean {
  return Boolean(
    postHog.featureFlags.isFeatureEnabled(getPostHogKey(key)) ||
    postHog.featureFlags.isFeatureEnabled(key)
  );
}

export function isCertificationModeEnabled() {
  return isEnabled("certification_mode");
}

export function isSSOEnabled() {
  return isEnabled("sso_login");
}

/**
 * Routes native login, session refresh and logout through the backend's
 * /auth/* endpoints instead of driving Cognito SRP in the browser.
 */
export function isBackendAuthEnabled() {
  return isEnabled("backend_auth");
}

/**
 * Swaps the team dashboard's two date range buttons for a select carrying an
 * "All Time" range. Temporary: retire it once the range has shipped.
 */
export function isAllTimeDateRangeEnabled() {
  return isEnabled("all_time_date_range");
}

/**
 * Shows the backend-formatted `label` (e.g. "N/A") in the team leaderboard
 * instead of the raw score / session count. Temporary: retire it once the
 * backend and iOS changes have shipped everywhere.
 */
export function isLeaderboardLabelEnabled() {
  return isEnabled("leaderboard_label");
}

export function isNotificationEnabled() {
  return isEnabled("notification");
}

export function isChatbotEnabled() {
  return isEnabled("chatbot");
}

export function isComplianceAcknowledgementEnabled() {
  return isEnabled("compliance_acknowledgement");
}

export function isAIRecommendationEnabled() {
  return isEnabled("ai_recommendation");
}

export function isCertificationOverallSummaryEnabled() {
  return isEnabled("certification_overall_summary");
}

export function isMyProfileEnabled() {
  return isEnabled("my_profile");
}

export function isAdminSettingsEnabled() {
  return isEnabled("admin_settings");
}

export function isCallFocusEnabled() {
  return isEnabled("call_focus");
}

export function isCallDetailsEnabled() {
  return isEnabled("call_details");
}

export function isBadgeCenterEnabled() {
  return isEnabled("badge_center");
}

export function isFeedbackTimeoutTestingEnabled() {
  return isEnabled("feedback_timeout_testing");
}

export function isReleaseBannerEnabled() {
  return isEnabled("release_banner");
}

export function isEngagementReportDisabled() {
  return isEnabled("disable_engagement_report");
}

/**
 * Hides every certification review action from managers so only admins can
 * review and approve certifications.
 */
export function isManagerCertificationReviewDisabled() {
  return isEnabled("disable_manager_certification_review");
}
